import { FilterAlt } from '@mui/icons-material'
import { Button, Popover } from '@mui/material'
import { useMemo, useRef, useState } from 'react'
import { Filters } from '@/features/search/filters/Filters'
import { useWindowWidth } from '@/layout/hooks/useWindowWidth'

export const SearchFilterPopover = () => {
  const ref = useRef<HTMLButtonElement>(null)
  const [isOpen, setOpen] = useState<boolean>(false)
  const open = Boolean(isOpen)

  const windowWidth = useWindowWidth()

  const handleClick = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  // Since we're using manually positioning this popover we need to
  // calculate the position based on element and window size
  const popoverPosition = useMemo(
    () => ({
      left: windowWidth / 2,
      top: (ref.current?.offsetTop ?? 0) + (ref.current?.offsetHeight ?? 0),
    }),
    [ref.current, windowWidth],
  )

  return (
    <>
      <Button
        ref={ref}
        title="Filters"
        disableElevation
        variant="outlined"
        color={'secondary'}
        onClick={handleClick}
        size="large"
        sx={{
          height: 56,
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
      >
        <FilterAlt />
      </Button>
      <Popover
        open={open}
        onClose={handleClose}
        anchorReference="anchorPosition"
        anchorEl={ref.current}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        anchorPosition={popoverPosition}
        slotProps={{
          backdrop: {
            sx: { background: '#0001' },
          },
        }}
      >
        <Filters onClose={handleClose} />
      </Popover>
    </>
  )
}
